import variables from '../variables';

const MuiPaginationItem = {
  styleOverrides: {
    root: {
      borderRadius: 0,
      backgroundColor: variables.colors.lightGrey,
      '&.Mui-selected': {
        backgroundColor: variables.colors.black,
        color: variables.colors.white,
      },
    },
  },
};

export default MuiPaginationItem;
